// export * from './environment.example'
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

// deploy config
export const environment = {

  // deploy config
  ENVIRONMENT: "uat",
  PRODUCTION: "false", // OCULTAR_CONSOLE_LOG

  ENABLE_MAINTENANCE_CURTAIN: "false", // Muestra página de sitio en construcción si es "true" (este flag es de todo el aplicativo, interno , vip, rds externo)
  ENABLE_MAINTENANCE_CURTAIN_VIP: "false", // Muestra página de cortina solo para usuarios VIP si es "true"

  // local development config
  IS_LOCAL: "false",  // if this is true show log messages with errors or mock data constructors

  // backend api integration or consume of mock data
  CONSUME_API_GET_PERSON_BY_ID: "true",     // true en producción mock buscador en false
  IUP_DEL_CONSUMO_GET_PERSON_BY_ID: "true", // true en producción mock resultado buscador en false
  CONSUME_API_MENU: "true",                 // true en producción
  CONSUME_API_ESTRUCTURA: "true",           // true en producción
  CONSUME_API_DATA: "true",                 // true en producción // for use true in local you need to set a valid key in MOCK_FUENTES and GET_PERSON_BY_ID
  CONSUME_API_SCHEMA: "true",               // true en producción
  ENCODE_PII_VALUE_DINAMIC: "true",         // true en producción
  CONSUME_API_SEGUIMIENTO: "true",          // true en producción
  CONSUME_API_DOMAINSLIST: "true",          // true en producción
  CONSUME_API_LOG: "true",                  // true en producción
  ACTIVE_DIS_MANUAL_SOURCES: "true",
  ACTIVE_GKL_NOMINATIVO: "true",
  MICROSERVICIO: "true",   // true = activo variable para activar rutas de microservicio

  // get dataview for manual sources
  MANUAL_DATAVIEWS: "true",           // true for calling backend and get the last version of dataview, false to use internal file

  // pinId configuracion Local
  HTTP_REQUEST_TIMEOUT: "180000",

  URL_RETURN_APP: "/int/home",
  URL_RETURN_APP_VIP: "/vip/home",
  URL_RETURN_APP_RDS: "/rdsportal/home",
  USE_LOGIN: "true", // if this is false pinId login its ignore, be careful on server you need mock data too if this is false

  DM_FUENTES_MANUALES: {
    bcra: {
      subdominios: ["AR_CREDIT/BCRA_FINANCIAL_STATUS", "AR_CREDIT/BCRA_FINANCIAL_STATUS_24M"]
    },
    bureau: {
      subdominios: ["AR_BUREAU_EXCH/LOAN", "AR_BUREAU_EXCH/CREDIT_CARD", "AR_BUREAU_EXCH/CHECKING_ACCOUNT", "AR_BUREAU_EXCH/OTHER_CREDIT"]
    },
    fintech: {
      subdominios: ["AR_FINTECH_EXCH/LOAN", "AR_FINTECH_EXCH/CREDIT_CARD"]
    }
  },

  // #UAT
  OKTA_REDIRECT_URI: "https://datatools.uat.intl.la-nane1.gcp.efx/sso/callback",
  OKTA_LOGOUT_URL: "https://business-uat.equifax.ca/auth/logout",
  VIP_URL_BASE_API: "https://api.uat.latam.equifax.com/datamaintenance",

  OKTA_COMMERCE_URL: "https://secure-uat.equifax.ca/auth/login",
  SECOND_BASE_URL: "/fedssoqa/as/token.oauth2",

  F_OKTA_PORTAL_URL: "https://datatools.uat.intl.la-nane1.gcp.efx/"

}

